import React from "react";
import { Button, Space } from "antd";
import { ColumnType } from "antd/lib/table";
import styles from "./LearningAssets.module.scss";

export interface AssetColumnHandlers<T> {
  isEditable: boolean;
  canDelete: boolean;
  onEdit: (record: T) => void;
  onDelete: (record: T) => void;
}

interface ActionHandlers<T> {
  canDelete?: boolean;
  isDisabled?: boolean;
  isSaving?: boolean;
  isEditing?: (record: T) => boolean;
  onEdit: (record: T) => void;
  onDelete: (record: T) => void;
  onSave?: () => void;
  onCancelEdit?: () => void;
}

function getActionColumn<T>({
  canDelete = true,
  isDisabled = false,
  isSaving = false,
  isEditing,
  onEdit,
  onDelete,
  onSave,
  onCancelEdit,
}: ActionHandlers<T>): ColumnType<T> {
  return {
    title: "Action",
    dataIndex: "action",
    key: "action",
    width: 160,
    render: (_, record) =>
      isEditing?.(record) ? (
        <Space size={12}>
          <Button type="link" className={styles.linkButton} disabled={isSaving} onClick={onSave}>
            Save
          </Button>
          <Button type="link" className={styles.linkButton} disabled={isSaving} onClick={onCancelEdit}>
            Cancel
          </Button>
        </Space>
      ) : (
        <Space size={12}>
          <Button type="link" className={styles.linkButton} disabled={isDisabled} onClick={() => onEdit(record)}>
            Edit
          </Button>
          <Button
            type="link"
            className={styles.linkButton}
            disabled={isDisabled || !canDelete}
            onClick={() => onDelete(record)}
          >
            Delete
          </Button>
        </Space>
      ),
  };
}

export default getActionColumn;
